import { useMediaQuery } from "@indietabletop/appkit/use-media-query";
import { ReactNode } from "react";
import { MinWidth } from "../media";
import { Spine } from "../spine";
import { root } from "./style.css";

export function MainLayout(props: { children: ReactNode }) {
  const withSpine = useMediaQuery(MinWidth.MEDIUM);

  return (
    <div className={root({ withSpine })}>
      {withSpine && <Spine />}
      <div>{props.children}</div>
    </div>
  );
}
